import { useId } from 'react';

function Coin({ empty = false }) {
  const gradient = `fc-coin-${useId().replace(/:/g, '')}`;
  return <svg className={`fc-coin ${empty ? 'fc-coin--empty' : ''}`} viewBox="0 0 64 64"
    aria-hidden="true" focusable="false">
    <defs><linearGradient id={gradient} x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stopColor="var(--fc-coin-highlight)" />
      <stop offset=".45" stopColor="var(--fc-copper)" />
      <stop offset="1" stopColor="var(--fc-coin-lowlight)" />
    </linearGradient></defs>
    <circle className="fc-coin__rim" cx="32" cy="32" r="30" fill={empty ? 'var(--fc-canvas)' : `url(#${gradient})`} />
    <circle className="fc-coin__milling" cx="32" cy="32" r="26" fill="none" strokeWidth="2" strokeDasharray="1 4" />
    <circle className="fc-coin__face" cx="32" cy="32" r="22" />
    <path className="fc-coin__pitch" d="M19 26h26v13H19zM32 26v13m-2-6.5a2 2 0 1 0 4 0 2 2 0 1 0-4 0" fill="none" strokeWidth=".8" />
    <text className="fc-coin__mark" x="32" y="38" textAnchor="middle">FC</text>
    <path className="fc-coin__detail" d="M29 16h6M29 48h6" fill="none" strokeWidth="1.5" />
  </svg>;
}

/** Display only. No allowance defaults, eligibility checks or activation action. */
export default function LastChanceChips({ count, compact = false }) {
  if (count === null || count === undefined) return <p className="fc-helper" role="status">Last Chance Chip balance unavailable</p>;
  if (!Number.isSafeInteger(count) || count < 0) {
    throw new Error('LastChanceChips requires a non-negative integer count.');
  }
  const label = `${count} Last Chance ${count === 1 ? 'Chip' : 'Chips'} remaining`;
  // Keep a large future balance compact while the visible text states its exact value.
  const coins = Math.min(count, 3);
  return <div className={`fc-chip-balance ${compact ? 'fc-chip-balance--compact' : ''}`} role="img" aria-label={label}>
    <div className="fc-coin-stack" aria-hidden="true">
      {count === 0 ? <Coin empty /> : Array.from({ length: coins }, (_, index) => <Coin key={index} />)}
      {count > coins && <span className="fc-chip-overflow">+{count - coins}</span>}
    </div>
    <p className="fc-chip-balance__label" aria-hidden="true">
      <strong>{count}</strong> Last Chance {count === 1 ? 'Chip' : 'Chips'}<span>remaining</span>
    </p>
  </div>;
}
